import React, { Component } from "react";
import joint from "jointjs";
import "../../../../node_modules/jointjs/dist/joint.css";
import Elements from "./elements";
import constants from "../utilities/constants";
import { buildFunnelBaseUrl } from "../../../api/urls";
import { getFunnel } from "../../actions";
import { generateVisualizerModel } from "../../visualizer/utilities/generateModel/generate-visualizer-model";

export default class screenshot extends Component {
    constructor() {
        super();
        this.stencil = new joint.dia.Graph();
        this.toolBar = new joint.dia.Graph();
        this.stencilPaper = new joint.dia.Paper();
        this.state = {
            presellPage: [constants.presellPageSvg].join(""),
            checkoutPage: [constants.checkoutPageSvg].join(""),
            upsellPage: [constants.upsellPageSvg].join(""),
            thankyouPage: [constants.thankyouPageSvg].join(""),
            blankPage: [constants.blankPageSvg].join(""),
            optInPage: [constants.optInPageSvg].join(""),
            downloadPage: [constants.downloadPageSvg].join(""),
            salesVideoPage: [constants.salesVideoPageSvg].join(""),
            calendarPage: [constants.calendarPageSvg].join(""),
            surveyPage: [constants.surveyPageSvg].join(""),
            webinarPage: [constants.webinarPageSvg].join(""),
            webinarReplayPage: [constants.webinarReplayPageSvg].join(""),
            blogPostPage: [constants.blogPostPageSvg].join(""),
            membersAreaPage: [constants.membersAreaPageSvg].join(""),
            popUpPage: [constants.popUpPageSvg].join(""),
            emailPage: [constants.emailPageSvg].join(""),
            textPage: [constants.textPageSvg].join(""),
            paperScale: 1,
        };
        const pathName = window.location.pathname;
        const referenceId = pathName.split("/").slice(-1)[0];
        getFunnel(referenceId).then((response) => {
            const components = response.components;
            const funnelPages = response.page;
            return this.getGraph(
                generateVisualizerModel(
                    components,
                    funnelPages
                )
            );
        });
    }

    componentDidMount() {
        this.visualizerInitialize();
    }

    visualizerInitialize = () => {
        const { leadPage, presellPage, checkoutPage, upsellPage, thankyouPage, blankPage, optInPage, downloadPage, salesVideoPage, calendarPage, surveyPage, webinarPage, webinarReplayPage, blogPostPage, membersAreaPage, popUpPage, emailPage, textPage } = this.state;
        this.stencilPaper = new joint.dia.Paper({
            el: this.refs.visualizer,
            model: this.stencil,
            width: window.innerWidth,
            height: window.innerHeight,
            background: {
                color: "#fff"
            },
            interactive: false
        });

        const presell = Elements(presellPage, constants.presellPagePositionX, constants.presellPagePositionY, constants.presellPageLabel, 1, false);
        const lead = Elements(leadPage, constants.leadPagePositionX, constants.leadPagePositionY, constants.leadPageLabel, 2, false);
        const checkout = Elements(checkoutPage, constants.checkoutPagePositionX, constants.checkoutPagePositionY, constants.checkoutPageLabel, 4, false);
        const upsell = Elements(upsellPage, constants.upsellPagePositionX, constants.upsellPagePositionY, constants.upsellPageLabel, 3, false);
        const thankyou = Elements(thankyouPage, constants.thankyouPagePositionX, constants.thankyouPagePositionY, constants.thankyouPageLabel, 5, false);
        const blank = Elements(blankPage, constants.blankPagePositionX, constants.blankPagePositionY, constants.blankPageLabel, null, false);
        const optIn = Elements(optInPage, constants.optInPagePositionX, constants.optInPagePositionY, constants.optInPageLabel, null, false);
        const download = Elements(downloadPage, constants.downloadPagePositionX, constants.downloadPagePositionY, constants.downloadPageLabel, null, false);
        const salesVideo = Elements(salesVideoPage, constants.salesVideoPagePositionX, constants.salesVideoPagePositionY, constants.salesVideoPageLabel, null, false);
        const calendar = Elements(calendarPage, constants.calendarPagePositionX, constants.calendarPagePositionY, constants.calendarPageLabel, null, false);
        const survey = Elements(surveyPage, constants.surveyPagePositionX, constants.surveyPagePositionY, constants.surveyPageLabel, null, false);
        const webinar = Elements(webinarPage, constants.webinarPagePositionX, constants.webinarPagePositionY, constants.webinarPageLabel, null, false);
        const webinarReplay = Elements(webinarReplayPage, constants.webinarReplayPagePositionX, constants.webinarReplayPagePositionY, constants.webinarReplayPageLabel, null, false);
        const blogPost = Elements(blogPostPage, constants.blogPostPagePositionX, constants.blogPostPagePositionY, constants.blogPostPageLabel, null, false);
        const membersArea = Elements(membersAreaPage, constants.membersAreaPagePositionX, constants.membersAreaPagePositionY, constants.membersAreaPageLabel, null, false);
        const popUp = Elements(popUpPage, constants.popUpPagePositionX, constants.popUpPagePositionY, constants.popUpPageLabel, null, false);
        const email = Elements(emailPage, constants.emailPagePositionX, constants.emailPagePositionY, constants.emailPageLabel, null, true);
        const text = Elements(textPage, constants.textPagePositionX, constants.textPagePositionY, constants.textPageLabel, null, true);
        this.toolBar.addCell([
            presell,
            lead,
            checkout,
            upsell,
            thankyou,
            blank,
            optIn,
            download,
            salesVideo,
            calendar,
            survey,
            webinar,
            webinarReplay,
            blogPost,
            membersArea,
            popUp,
            email,
            text,
        ]);
    }

    getGraph = (metaJsonVisualizer) => {
        this.stencil.fromJSON(metaJsonVisualizer);
        this.stencilPaper.scaleContentToFit({ padding: 32 });
    }
    render() {
        return (
            <>
                <div ref="visualizer"
                    style={{
                        width: window.innerWidth,
                        height: window.innerHeight
                    }}
                />
            </>
        );
    }
}